// extracted by mini-css-extract-plugin
module.exports = {"box":"SMESectors_box__38ohV","content":"SMESectors_content__ArKaY"};